import { digObject, toggleArray } from '@domain-group/javascript-utils'

import {
  Box, ListItem, Text, ToggleButton,
} from '@domain-group/suit-theme'

import useAgency from '@hooks/useAgency'
import usePortalOptionValues from '@hooks/usePortalOptionValues'

import handleCallbackAction from '@functions/handleCallbackAction'

import { AgencyModel, PortalModel, PortalOptionModel } from '@models/types'

type UpdateOptionsParams = {
  agencyOptions: {
    disabled_portal_option_values:{
      [key: string]: string,
    },
  },
  portal: PortalModel,
  portalOptionValueId: number,
  updateAgencyFn:(agencyParams: AgencyModel)=> void,
}

const updateOptions = (params: UpdateOptionsParams) => {
  const {
    agencyOptions, portal, portalOptionValueId, updateAgencyFn,
  } = params

  const { disabled_portal_option_values = {} } = agencyOptions || {}

  const disabledIdsForPortal = digObject(disabled_portal_option_values, portal.short_code, [])
  const updatedIds = toggleArray(disabledIdsForPortal, portalOptionValueId)

  const updateAgencyOptionPayload = {
    callbacks: {
      action: updateAgencyFn,
    },
    entityParams: {
      options: {
        disabled_portal_option_values: { ...disabled_portal_option_values, [portal.short_code]: updatedIds },
      },
    },
    toastText: 'Agency Options Updated',
  }

  // @ts-expect-error TS2345
  return handleCallbackAction(updateAgencyOptionPayload)
}

interface PortalOptionsProps {
  disabled: boolean,
  portal: PortalModel,
  portalOption: PortalOptionModel,
  selectedAgencyId: number,
}

const PortalOptions = (props: PortalOptionsProps) => {
  const {
    disabled = false,
    portal,
    portalOption,
    selectedAgencyId,
  } = props

  const { filteredPortalOptionValues } = usePortalOptionValues({ filters: { portal_option_id: portalOption.id } })

  const { agency, callbacks: { updateAgency: updateAgencyFn } } = useAgency({ id: selectedAgencyId })

  const agencyOptions = digObject(agency, 'options')

  const disabledPortalOptionValues = digObject(
    agencyOptions,
    `disabled_portal_option_values.${portal?.short_code}`,
    [],
  )

  return (
    <>
      {filteredPortalOptionValues.map(portalOptionValue => (
        <ListItem
          boxProps={{ alignItems: 'center', paddingY: 'medium' }}
          disableHover
          key={portalOptionValue.id}
        >
          <Text color="bodyFontColor" fontSize="small" variant="ellipsis">{portalOptionValue.title}</Text>

          <Box justifyContent="flex-end">
            <ToggleButton
              // @ts-expect-error TS2322
              disabled={disabled}
              onClick={() => (disabled ? null : updateOptions({
                agencyOptions, portal, portalOptionValueId: portalOptionValue.id, updateAgencyFn,
              }))}
              toggleOn={!disabledPortalOptionValues.includes(portalOptionValue.id)}
            />
          </Box>
        </ListItem>
      ))}

    </>

  )
}

export default PortalOptions
